import Vue from "vue";
import Router from "vue-router";
const entrance = () => import("./views/entrance");//入口
const SFBentrance = () => import("./views/SFBentrance");//随身办入口
const List = () => import("./views/List");//景点列表
const appointment = () => import("./views/appointment");//景点门票
const PCappointment = () => import("./views/PCappointment");//景点门票pc端
const hotel = () => import("./views/hotel");//酒店流调表
const orderCenter = () => import("./views/orderCenter");//订单列表
const orderDetails = () => import("./views/orderDetails");//订单详情
const chart = () => import("./views/chart");//图表
const report = () => import("./views/report");//报告
const Focus = () => import("./views/Focus");//关注公众号
const getId = () => import("./views/userId");
const sanOrder = () => import("./views/sanOrder");
const tuanOrder = () => import("./views/tuanOrder");

import NewAppoint from "../src/views/newAppoint.vue"
import NewOrderCenter from "../src/views/newOrderCenter.vue"

import { getToken } from "./token";
Vue.use(Router);
//没有token时也不跳转的页面
let wxlist = ['List', 'Focus', 'PCappointment', 'SFBentrance']

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "List",
      component: List
    },
    // new 
    {
      path: "/newAppoint/:id",
      name: "newAppoint",
      component: NewAppoint
    },
    {
      path: "/newOrderCenter",
      name: "newOrderCenter",
      component: NewOrderCenter
    },
    {
      path: "/entrance",
      name: "entrance",
      component: entrance
    },
    {
      path: "/sanorder",
      name: "sanorder",
      component: sanOrder
    },
    {
      path: "/tuanorder",
      name: "tuanorder",
      component: tuanOrder
    },
    {
      path: "/chart",
      name: "chart",
      component: chart
    },
    {
      path: "/report",
      name: "report",
      component: report
    },
    {
      path: "/appointment/:id",
      name: "appointment",
      component: appointment
    },
    {
      path: "/PCappointment/:id/:token",
      name: "PCappointment",
      component: PCappointment
    },
    {
      path: "/hotel",
      name: "hotel",
      component: hotel
    },
    {
      path: "/orderCenter",
      name: "orderCenter",
      component: orderCenter
    },
    {
      path: "/Focus",
      name: "Focus",
      component: Focus
    },
    {
      path: "/orderDetails/:id",
      name: "orderDetails",
      component: orderDetails
    },
    {
      path: "/getId",
      name: "getId",
      component: getId
    },

    //随身办登录
    {
      path: "/SFB",
      name: "List",
      component: List
    },
    {
      path: "/SFBentrance",
      name: "SFBentrance",
      component: SFBentrance
    },
    {
      path: "/SFBchart",
      name: "chart",
      component: chart
    },
    {
      path: "/SFBreport",
      name: "report",
      component: report
    },
    {
      path: "/SFBappointment/:id",
      name: "appointment",
      component: appointment
    },
    {
      path: "/SFBPCappointment/:id/:token",
      name: "PCappointment",
      component: PCappointment
    },
    {
      path: "/SFBhotel",
      name: "hotel",
      component: hotel
    },
    {
      path: "/SFBorderCenter",
      name: "orderCenter",
      component: orderCenter
    },
    {
      path: "/SFBorderDetails/:id",
      name: "orderDetails",
      component: orderDetails
    },
  ]
});
router.beforeEach((to, from, next) => {
  if (wxlist.lastIndexOf(to.name) == -1) {
    if (getToken()) {
      next()
    } else {
      next()
      let result = to.path.slice(0, 4) == "/SFB"
      if (result) return next("/SFBentrance?redirect=" + to.path)
      if (!result) return next("/?redirect=" + to.path)

    }

  } else {
    next()
  }
})
export default router;